/**
 * @param {string} utmString "123123123.124214.11.1.utmcsr=google|utmccn=(organic)|utmcmd=organic|utmctr=(not provided)"
 * @returns {array}
 */
export const parseUTMParams = (utmString: string) =>
  utmString.split('.').pop()?.split('|');
